import { render, staticRenderFns } from "./BaseColor.vue?vue&type=template&id=f003fefe&"
import script from "./BaseColor.vue?vue&type=script&lang=js&"
export * from "./BaseColor.vue?vue&type=script&lang=js&"
import style0 from "./BaseColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports